import config from '../../../assets/js/conf/config';
import md5 from 'js-md5';
import { addAddressData, getAddressData, setDefAddressData, updateAddressData, delAddressData } from "../../../api/address";


let modules = {
  namespaced: true,
  state: {
    address: [],
  },
  mutations: {

    ["SET_ADDRESS"](state, payload) {
      state.address = payload.address_list;
    },

    // 设置默认地址
    ["SET_DEF_ADDRESS"](state, payload) {
      for (let i in state.address) {
        state.address[i].isdefault = 0;
      }
      state.address[payload.index].isdefault = payload.isdefault;
    },

    //删除收货地址
    ["DEL_ADDRESS"](state, payload) {
      state.address.splice(payload.index, 1);
    },


  },
  actions: {

    //添加收货地址
    addAddress(conText, payload) {

      let address_key = config.addressKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security + '|' + payload.data.province + '|' + payload.data.city + '|' + payload.data.county) + '|' + address_key);
      let data = {
        guid,
        security,
        token,
        ...payload.data

      }
      // console.log(data)
      addAddressData(JSON.stringify(data)).then(res => {
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    //收货地址列表
    getAddress(conText, payload) {

      // console.log(res)            
      let address_key = config.addressKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security) + '|' + address_key);
      let data = {
        guid,
        security,
        token,
      }
      // console.log(data)            
      getAddressData(JSON.stringify(data)).then(res => {
        // console.log(res)

        if (res.status == 1) {
          conText.commit("SET_ADDRESS", { address_list: res.address_list });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    //设置默认收货地址
    setDefAddress(conText, payload) {

      let index = payload.data.index;
      let addressList = conText.state.address;
      let isdefault = 0;
      // console.log(addressList);
      if (parseInt(addressList[index].isdefault) === 0) {
        isdefault = 1;
      }
      let address_key = config.addressKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let id = parseInt(payload.data.id);
      let token = md5(md5(guid + '|' + security + '|' + id + '|' + isdefault) + '|' + address_key);
      let data = {
        guid,
        security,
        token,
        isdefault,
        id,
      }

      setDefAddressData(JSON.stringify(data)).then(res => {
        // console.log(res)
        if (res.status == 1) {
          conText.commit("SET_DEF_ADDRESS", { index: index, isdefault: isdefault });
        }
        if (payload.success) {
          payload.success(res);
        }
      })

    },

    //修改收货地址
    updateAddress(conText, payload) {

      let address_key = config.addressKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let token = md5(md5(guid + '|' + security + '|' + payload.data.province + '|' + payload.data.city + '|' + payload.data.county) + '|' + address_key);
      let data = {
        guid,
        security,
        token,
        ...payload.data
      }

      updateAddressData(JSON.stringify(data)).then(res => {

        if (payload.success) {
          payload.success(res);
        }
      })

    },
    //删除收货地址
    delAddress(conText, payload) {
      let index = payload.data.index;
      let address_key = config.addressKey;
      let security = conText.rootState.user.security;
      let guid = conText.rootState.user.guid;
      let id = parseInt(payload.data.id);
      let token = md5(md5(guid + '|' + security + '|' + id) + '|' + address_key);
      let data = {
        guid,
        security,
        token,
        id,
      }
      delAddressData(JSON.stringify(data)).then(res => {
        console.log(res)
        if (res.status == 1) {
          conText.commit("DEL_ADDRESS", { index: index });
        }
        if (payload.success) {
          payload.success(res);
        }
      })
    },


  }

}
export default modules;